import {
    AgileArticleOneQuery,
    getAgileArticleQueryVars
} from "@/contentful/graphql";
import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import { init as initRelay } from "../init-relay-streaming";
import { AgileArticlePage } from "../pages/agile/article/agile-article-page";

initRelay(
    AgileArticlePage,
    AgileArticleOneQuery,
    getAgileArticleQueryVars(window.location),
    RELAY_API_CONTENTFUL
);
